module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-bb08ec26.png";